<template>
    <div class="max-w-4xl rounded-xl shadow bg-white  p-4">
        <div
            class="w-full grid grid-cols-12 gap-4"
        >
            <input-text
                label="Table Heading"
                name="table_heading"
                v-model="heading"
                @input="buildData"
                class="col-span-10"
            >
                <p class="text-xs text-gray-600">
                    You can use these available shortcodes in the heading field
                    above: [current_year], [current_month] and [current_abrev_month]
                </p>
            </input-text>
            <Select
                class="col-span-2"
                label="Heading Type"
                name="heading_type"
                v-model="headingType"
                @input="buildData"
                placeholder="Heading"
                unsettable
                :options="[
                    { value: 'H2', name: 'H2' },
                    { value: 'H3', name: 'H3' },
                    { value: 'H4', name: 'H4' },
                    { value: 'H5', name: 'H5' },
                    { value: 'H6', name: 'H6' },
                ]"
            />
            <div
                class="col-span-12 flex flex-row justify-between items-center"
                v-if="!Object.keys(tables).length"
            >
                <Btn
                    @click="initializeTable"
                    type="button"
                    content="+ Create New Table"
                />
                <duplicate-from-casino-review
                    :language="language"
                    @duplicated="duplicateTable"
                ></duplicate-from-casino-review>
            </div>
            <div class="col-span-12" v-if="Object.keys(tables).length">
                <row-builder
                    v-model="tables"
                    @input="buildData"
                    :casino="casino"
                    :language="language"
                ></row-builder>
                <Btn
                    v-if="tables !== null"
                    @click="handleAddRow"
                    class="mt-3"
                    type="button"
                    content="+ Add New Row"
                />
            </div>
        </div>
        <error class="mt-3" :error="error" />
    </div>
</template>

<script>
import siteLanguage from '../../config/siteLanguage'

export default {
    name: "TableBase",
    props: {
        value: {
            type: [String, Object],
        },
        casino: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
    },
    data() {
        return {
            heading: JSON.parse(this.value)
                ? JSON.parse(this.value).heading
                : "",
            headingType: JSON.parse(this.value)
                ? JSON.parse(this.value).headingType
                : "H2",
            documentType: "casino",
            tables: JSON.parse(this.value) ? JSON.parse(this.value).tables : {},
        };
    },
    methods: {
        buildData() {
            this.$emit(
                "input",
                JSON.stringify({
                    heading: this.heading,
                    headingType: this.headingType,
                    documentType: this.documentType,
                    tables: this.tables,
                })
            );
        },
        initializeTable() {
            this.tables = [
                {
                    leftTable: {
                        attribute: null,
                        label: null,
                        value: null,
                        data: null,
                        link: null
                    },
                    rightTable: {
                        attribute: null,
                        label: null,
                        value: null,
                        data: null,
                        link: null,
                    },
                },
            ];
        },
        handleAddRow() {
            this.tables.push({
                leftTable: {
                    attribute: null,
                    label: null,
                    value: null,
                    data: null,
                    link: null,
                },
                rightTable: {
                    attribute: null,
                    label: null,
                    value: null,
                    data: null,
                    link: null,
                },
            });
        },
        duplicateTable(casinoReview) {
            if (casinoReview.two_col_four_table) {
                this.tables = JSON.parse(
                    casinoReview.two_col_four_table
                ).tables;
            }
            this.buildData();
        },
    },
};
</script>

<style></style>
